/* eslint-disable */
import Vuex from 'vuex'
import Vue from 'vue'
import axios from 'axios'

Vue.use(Vuex)
export const store = new Vuex.Store({
    state: {
      emotes: [],
      latest: [],
      skins: [],
      leaks: [],
      sitestats: null,
      modalVideo: ''
    },
    getters: {
      getEmotes: state => {
        return state.emotes;
      }
    },
    mutations: {
      update (state,payload){
        console.log(state.emotes[0].name)
      },
      setModalVideo (state, videoId) {
        state.modalVideo = videoId
      }
    },
    actions: {
        loadEmotes(context){
            if(context.state.emotes.length > 0) {
                console.log("Already has data...")
                return;
            }
            console.log(context.state.emotes.length)

            axios
            .get(process.env.EMOTES_API)
            .then(resp => {
                context.state.emotes = resp.data
                console.log(context.state.emotes.length)
                //console.log(resp);
            })
            .catch(err => {
                console.log(err);
            }); 
        },
        loadLatest(context){
            if(context.state.latest.length > 0) {
                console.log("Already has data...")
                return;
            }
            console.log(context.state.latest.length)

            axios
            .get(process.env.LATEST_API)
            .then(resp => {
                context.state.latest = resp.data
                console.log(context.state.latest.length)
                //console.log(resp);
            })
            .catch(err => {
                console.log(err);
            }); 
        },
        loadSkins(context){
          if(context.state.skins.length > 0) {
              console.log("Already has data...")
              return;
          }
          console.log(context.state.skins.length)

          axios
          .get(process.env.SKINS_API)
          .then(resp => {
              context.state.skins = resp.data
              console.log(context.state.skins.length)
              //console.log(resp);
          })
          .catch(err => {
              console.log(err);
          }); 
        },
        loadLeaks(context){
            if(context.state.leaks.length > 0) {
                console.log("Already has data...")
                return;
            }
            console.log(context.state.leaks.length)

            axios
            .get(process.env.LEAKS_API)
            .then(resp => {
                context.state.leaks = resp.data
                console.log(context.state.leaks.length)
                //console.log(resp);
            })
            .catch(err => {
                console.log(err);
            }); 
            },
        loadSiteStats(context){
            if(context.state.sitestats != null) {
                console.log("Already has data...")
                return;
            }

            axios
            .get(process.env.SITESTATS_API)
            .then(resp => {
                context.state.sitestats = resp.data
                console.log(context.state.sitestats.totalVideos)
                //console.log(resp);
            })
            .catch(err => {
                console.log(err);
            }); 
        }

    }
})


// WEBPACK FOOTER //
// ./src/store.js